/* eslint-disable import/prefer-default-export */
import { api } from '../http';

export const negotiationItems = (auctionId, data) =>
  api.post(`/auctions/${auctionId}/negotiation/`, data);
